import { saveAs } from 'file-saver';
import { bufferToUrl, firefoxWorkaroundPdfDownload } from '../helpers';
export default [
    '$rootScope',
    '$document',
    'LogService',
    'MediaboxService',
    function ($rootScope, $document, logService, mediaboxService) {
        const log = logService.getLogger('Mediabox-C');
        return {
            restrict: 'E',
            scope: {},
            bindToController: {},
            controllerAs: 'ctrl',
            controller: [function () {
                    this.imageDataUrl = null;
                    this.caption = '';
                    this.close = ($event) => {
                        if ($event !== undefined) {
                            if ($event.target === $event.currentTarget) {
                                this.imageDataUrl = null;
                            }
                        }
                        else {
                            this.imageDataUrl = null;
                        }
                    };
                    this.save = () => {
                        saveAs(new Blob([mediaboxService.data], {
                            type: firefoxWorkaroundPdfDownload(mediaboxService.mimetype),
                        }), mediaboxService.filename || 'image.jpg');
                    };
                    mediaboxService.evtMediaChanged.attach((dataAvailable) => {
                        $rootScope.$apply(() => {
                            if (dataAvailable) {
                                this.imageDataUrl = bufferToUrl(mediaboxService.data, mediaboxService.mimetype, log);
                                this.caption = mediaboxService.caption || mediaboxService.filename;
                            }
                            else {
                                this.close();
                            }
                        });
                    });
                }],
            link($scope, $element, attrs) {
                $document.on('keyup', (e) => {
                    const ke = e;
                    if (ke.key === 'Escape' && $scope.ctrl.imageDataUrl !== null) {
                        $scope.$apply($scope.ctrl.close);
                    }
                });
            },
            template: `
                <div class="box" ng-if="ctrl.imageDataUrl !== null">
                    <md-icon class="save material-icons md-24" ng-click="ctrl.save()" aria-label="Save" translate-attr="{'aria-label': 'common.SAVE', 'title': 'common.SAVE'}">save</md-icon>
                    <md-icon class="close material-icons md-24" ng-click="ctrl.close()" aria-label="Close" translate-attr="{'aria-label': 'common.CLOSE', 'title': 'common.CLOSE'}">close</md-icon>
                    <div class="inner" ng-click="ctrl.close($event)">
                        <img ng-src="{{ ctrl.imageDataUrl }}">
                        <div class="caption" title="{{ ctrl.caption | escapeHtml}}">
                            <span ng-bind-html="ctrl.caption | escapeHtml | markify | emojify"></span>
                        </div>
                    </div>
                </div>
            `,
        };
    },
];
